/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.ALL_ACC_REC_NDC_TABLE:
      return { ...state, getAllAccRecNDCList: action.getAllAccRecNDCList };
    case actiontypes.ALL_ACC_REC_FIELD_VALUES:
      return { ...state, getAccRecFieldvalues: action.getAccRecFieldvalues };
    case actiontypes.ACC_REBATE_PGM_NAME:
      return { ...state, rebate_pgm_name: action.payload };
    case actiontypes.ACC_REBATE_PGM:
      return { ...state, rebate_pgm_code: action.payload };
    case actiontypes.QTR_ACCOUNT_REC_ALL_FIELD_CLEAR_REDUX:
      return action.payload ? action.payload : {};
    default:
      return state;
  }
};

export default reducer;
